import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-optimo-device',
  templateUrl: './optimo-device.component.svg',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptimoDeviceComponent {}
